import api from './api';
import { ApiResponse } from '../api-helpers';

export interface CustomerConsistencyQuery {
  codeLike?: string; // e.g. 'A%'
  limit?: number;
  offset?: number;
  includeEqualSummary?: boolean; // optional
}

export interface DbPresence {
  [dbName: string]: boolean;
}

export interface EqualFlags {
  [flag: string]: 0 | 1;
}

export interface DbValues {
  [dbName: string]: Record<string, any> | null;
}

export interface CustomerConsistencyRow {
  customerCode: string;
  presence: DbPresence;
  equalFlags: EqualFlags;
  values: DbValues;
}

export interface CustomerConsistencyResponse {
  meta: {
    total: number;
    limit: number;
    offset: number;
    queriedAt: string;
  };
  databases: string[];
  rows: CustomerConsistencyRow[];
}

const reportsApi = {
  async getCustomerConsistency(payload: CustomerConsistencyQuery) {
    const { data } = await api.post<ApiResponse<CustomerConsistencyResponse>>(
      '/api/v1/reports/customer-consistency',
      payload
    );
    // Backend ApiResponse ile sarmalıyor, gerçek veriyi döndür
    return data.data;
  },
};

export default reportsApi;
